import { settings } from 'settings';
import Fetch from 'utils/fetch';
import { CourierJson } from '../types/bundleTypes';
import { Region } from '../types/orderTypes';
import { queryStringFromObject } from '../utils/urlUtil';
import { ERROR } from './../const/error';

export async function fetchCouriers(): Promise<CourierJson[]> {
  try {
    const url = `${settings.newApiUrl}/courier`;
    const response = await Fetch.get({ url });
    if (response.ok) return response.json();
  } catch (e) {
    console.log(ERROR.FETCH_COURIERS, e);
  }
  return [];
}

export async function fetchCouriersByRegion(
  region: Region
): Promise<CourierJson[]> {
  try {
    const queryString = queryStringFromObject({ region });
    const url = `${settings.newApiUrl}/courier/byRegion${queryString}`;
    const response = await Fetch.get({ url });
    if (response.ok) return response.json();
  } catch (e) {
    console.log(ERROR.FETCH_COURIERS, e);
  }
  return [];
}

export async function fetchCourier(
  courierId: string
): Promise<CourierJson | null> {
  try {
    const url = `${settings.newApiUrl}/courier/${courierId}`;
    const response: Response = await Fetch.get({ url });
    return response.ok ? await response.json() : null;
  } catch (e) {
    console.log(`Error fetching courier ${courierId}`, e);
    return null;
  }
}
